module.exports = __webpack_public_path__ + "static/media/notification-admin.0587794a.mp3";